export default __webpack_public_path__ + "media/zurb/img/home/firefox-logo-6d6067a26cbd4f17cc59737daaa1e0db.svg";